<template>
    <a-modal
        v-model="visible"
        title="Alta de clientes"
        ok-text="Crear y continuar"
        :loading="loading"
        @ok="save"
        @cancel="$emit('close')"
    >
        <div class="row">
            <div class="col-12">
                <g-field v-model="fields.name" :app="app" :item="id" name="name" title="Nombre" />
            </div>
            <div class="col-12">
                <g-field v-model="fields.alias" :app="app" :item="id" name="alias" title="Alias" />
            </div>
            <div class="col-12">
                <g-field v-model="fields.email" :app="app" :item="id" name="email" title="Email" />
            </div>
        </div>
        <div class="row">
            <div class="col-6">
                <g-field v-model="fields.legal_name" :app="app" :item="id" name="legal_name" title="Razón Social" />
            </div>
            <div class="col-6">
                <g-field v-model="fields.cif" :app="app" :item="id" name="cif" title="NIF / CIF" />
            </div>
        </div>
    </a-modal>
</template>
<script>
export default {
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        id: {
            type: Number,
            default: null,
        },
    },
    data() {
        return {
            view: 'clientList',
            app: 'clients',
            loading: false,
            fields: {
                name: '',
                legal_name: '',
                alias: '',
                email: '',
                cif: '',
            },
        }
    },
    methods: {
        async save() {
            this.loading = true

            const params = {
                ...this.fields,
            }

            let data
            if (this.id > 0) {
                // data = await this.$gestios.items('clients').edit({ id: this.id, params });
                this.$gestios.$message.error('Edite al cliente desde la seleccion en la tabla')
            } else {
                data = await this.$gestios.items('clients').add({ params, view: this.view })
            }

            if (data.ok) {
                const id = data.data._EntityId
                setTimeout(() => {
                    this.$router.push(`client/${id}?edit=1`)
                    this.$emit('close')
                })
            } else {
                this.$gestios.$message.error('Ocurrio un error al dar de alta el nuevo cliente')
            }

            this.loading = false
        },
    },
}
</script>

<style></style>
